var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLibraryEmpty = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50:1016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2108 0.900392C29.731 -3.31404 38.9503 8.74656 66.9842 6.72742C99.1647 4.42371 91.3812 37.3803 63.911 51.8124C34.3474 67.3421 5.29363 67.8977 0.449112 33.7079C0.475952 33.6944 -4.07334 6.5106 15.2108 0.900392Z",
    fill: "#E1E9F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9769 32.5093C28.9395 32.5063 28.902 32.5034 28.8618 32.489C26.2919 31.8453 23.9672 30.5656 22.1466 28.8056C16.6386 23.4883 17.3726 15.6858 17.5839 14.1778C17.6504 13.7087 18.0594 13.3866 18.5169 13.456C18.9717 13.5139 19.2851 13.9373 19.2185 14.4064C19.0333 15.7734 18.369 22.8247 23.2844 27.5803C24.9095 29.1444 26.9781 30.28 29.2746 30.8573C29.7177 30.9671 29.9793 31.4278 29.8725 31.8825C29.7657 32.2882 29.3798 32.5556 28.9769 32.5093Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2957 12.5909C16.2957 12.5909 14.7256 14.4865 16.6365 14.8419C18.5446 15.1858 17.8658 10.6952 16.2957 12.5909Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2162 11.2239C19.2162 11.2239 17.495 14.017 19.4186 14.3245C21.3339 14.6132 20.9375 8.43074 19.2162 11.2239Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6928 12.01C17.6928 12.01 15.8793 13.6685 17.7258 14.2864C19.5612 14.9002 19.5063 10.3516 17.6928 12.01Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3942 14.7148C17.5884 13.941 18.0985 13.4407 18.8378 13.3106C19.7188 13.1617 20.9314 13.5185 20.6615 14.5396C20.4895 15.1749 20.1785 15.4082 19.8347 15.425C19.164 15.4575 18.3942 14.7148 18.3942 14.7148Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 17C27 14.7909 28.7909 13 31 13H46.6C47.3732 13 48 13.6268 48 14.4C48 15.1732 48.6268 15.8 49.4 15.8H65C67.2091 15.8 69 17.5909 69 19.8V42.6C69 44.8091 67.2091 46.6 65 46.6H31C28.7909 46.6 27 44.8091 27 42.6V17Z",
    fill: "#00838F",
    stroke: "#00838F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 25.4C69 23.1909 67.2091 21.4 65 21.4H49.4C48.6268 21.4 48 22.0268 48 22.8C48 23.5732 47.3732 24.2 46.6 24.2H31C28.7909 24.2 27 25.9909 27 28.2V48.2C27 50.4092 28.7909 52.2 31 52.2H65C67.2091 52.2 69 50.4092 69 48.2V25.4Z",
    fill: "white",
    stroke: "#00838F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1422 39.7359C55.6714 38.1724 56.5573 36.5232 58.1208 36.0524C59.6844 35.5817 61.3335 36.4675 61.8043 38.0311C62.2751 39.5946 61.3892 41.2438 59.8257 41.7145C58.2621 42.1853 56.613 41.2995 56.1422 39.7359Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8431 38.1539C58.9494 38.707 59.4599 39.0686 60.013 38.9622C60.566 38.8559 60.9276 38.3453 60.8213 37.7923C60.7149 37.2392 60.2044 36.8776 59.6514 36.984C59.1196 37.0903 58.7367 37.6221 58.8431 38.1539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8535 41.6821C34.2776 41.2541 33.347 39.6295 33.775 38.0536C34.2029 36.4776 35.8275 35.547 37.4034 35.975C38.9794 36.403 39.91 38.0275 39.482 39.6035C39.054 41.1794 37.4295 42.1101 35.8535 41.6821Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5043 38.1248C36.6107 38.6779 37.1212 39.0395 37.6742 38.9331C38.2273 38.8268 38.5889 38.3162 38.4825 37.7632C38.3762 37.2101 37.8657 36.8485 37.3126 36.9549C36.7808 37.04 36.4192 37.5718 36.5043 38.1248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4111 45.9554C46.8522 46.1116 47.3547 46.2219 47.9187 46.2862C50.9744 46.5785 52.6427 44.4163 53.0888 43.2203C53.2166 42.8594 53.0353 42.4793 52.7015 42.3385C52.7015 42.3385 52.7015 42.3385 52.6815 42.3314C52.3406 42.2107 51.9605 42.392 51.8197 42.7258C51.7842 42.826 50.8319 45.1966 48.0381 44.9294C44.5931 44.5895 44.4263 41.6194 44.4088 41.4778C44.382 41.1073 44.0779 40.8191 43.7145 40.8258C43.344 40.8525 43.0557 41.1566 43.0624 41.52C43.126 42.8062 43.9047 45.0678 46.4111 45.9554Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 48,
    r: 2,
    fill: "#193E6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 54.5,
    r: 2.5,
    fill: "#193E6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 58,
    r: 6,
    fill: "#E1E9F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 61,
    r: 3,
    fill: "#193E6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50:1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 64,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLibraryEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/library-empty.ff1e79eb.svg";
export { ForwardRef as ReactComponent };